import React from "react";
import AddIcon from "@mui/icons-material/Add";
import RightSideModel from "src/components/popup/rightSide/RightSideModel";
import { allowedToCreateEntity } from "src/constants/role";
import useAuth from "src/hooks/useAuth";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import Controls from "src/components/form/controls/Controls";
import { isOpenPopup } from "src/utils/isOpenPopup";
import ReleaseTypeSpeakerForm from "../form/ReleaseTypeSpeakerForm/ReleaseTypeSpeakerForm";

const titlePopup = (isEdit) => {
  return isEdit ? "Edit Speaker Type" : "Create Speaker Type";
};

const ReleaseTypeSpeakerPopup = ({
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();
  return (
    <>
      {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
        <Controls.Button
          text="Add New"
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => handleOpenPopup(isOpenPopup, null)}
        />
      )}
      <RightSideModel
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        title={titlePopup(Boolean(recordForEdit))}
      >
        <ReleaseTypeSpeakerForm
          recordForEdit={recordForEdit}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </RightSideModel>
    </>
  );
};

export default ReleaseTypeSpeakerPopup;
